import { RPCDocs } from "../../services/rpc.js";
import { MdAssignmentInd, MdEventBusy, MdInfo, MdLogin, MdLogout, MdNotificationImportant, MdRateReview, MdSchedule } from "react-icons/md";
// src/modules/Notifications/constants.ts
var Category = RPCDocs.Notifications.FindMyNotifications.v1.Category;
var Priority = RPCDocs.Notifications.FindMyNotifications.v1.Priority;
var NOTIFICATION_CATEGORY_ICONS = {
	[Category.EventAssignment]: MdAssignmentInd,
	[Category.EventOpened]: MdNotificationImportant,
	[Category.ReportReview]: MdRateReview,
	[Category.ShiftClockIn]: MdLogin,
	[Category.ShiftClockOut]: MdLogout,
	[Category.ShiftRequest]: MdSchedule,
	[Category.System]: MdInfo,
	[Category.TimeOffDecision]: MdEventBusy,
	[Category.TimeOffWithdrawn]: MdEventBusy
};
var NOTIFICATION_CATEGORY_LABELS = {
	[Category.EventAssignment]: "Event assignment",
	[Category.EventOpened]: "Event opened",
	[Category.ReportReview]: "Report review",
	[Category.ShiftClockIn]: "Shift clock-in",
	[Category.ShiftClockOut]: "Shift clock-out",
	[Category.ShiftRequest]: "Shift request",
	[Category.System]: "System",
	[Category.TimeOffDecision]: "Time off decision",
	[Category.TimeOffWithdrawn]: "Time off withdrawn"
};
/** Priority is presentation-only — it drives urgency styling, never delivery. */
var NOTIFICATION_PRIORITY_VARIANTS = {
	[Priority.Critical]: "critical",
	[Priority.High]: "caution",
	[Priority.Low]: "neutral",
	[Priority.Normal]: "info"
};
/** Live-toast auto-close (ms) per priority; false = persistent until dismissed. */
var NOTIFICATION_TOAST_AUTO_CLOSE = {
	[Priority.Critical]: false,
	[Priority.High]: 1e4,
	[Priority.Low]: 5e3,
	[Priority.Normal]: 5e3
};
function getResolveActionLabel(category) {
	return category === Category.EventOpened ? "Take it" : "Resolve";
}
export { NOTIFICATION_CATEGORY_ICONS, NOTIFICATION_CATEGORY_LABELS, NOTIFICATION_PRIORITY_VARIANTS, NOTIFICATION_TOAST_AUTO_CLOSE, getResolveActionLabel };

//# sourceMappingURL=constants.js.map